import Service from "../service";

const CommunityAPI = {
  getCommunity(data) {
    return Service.get(`/api/getCommunity`, {
      params: {
        community_id: data.community_id,
        is_count: data.is_count,
      },
    });
  },
  listCommunity() {
    return Service.get(`/api/community`);
  },
  storeCommunity(data) {
    return Service.put(`/api/community/${data.community_id}`, data);
  },
  storeCommunityProgress(data) {
    return Service.post(`/api/communityProgress`, data);
  },
  storeCommunityProject(data) {
    return Service.post(`/api/communityProject`, data);
  },
};

export default CommunityAPI;
